CurrentUserModel.$inject = ["$modelFactory", "ApiHttp", "CheckinModel", "UserMealPlanModel", "UserSubscriptionPlanModel", "UserSubscriptionModel"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}export var userDefaults = {
  id: 0,
  email: "",
  username: "",
  uid: "",
  date_joined: "",
  last_login: "",
  last_checkin: null, /* CheckinModel */
  first_checkin: null, /* CheckinModel */
  age: 0,
  meal_plan: null, /* MealPlanModel */
  first_name: "",
  last_name: "",
  tagline: "",
  facebook_uid: null,
  height: 0,
  user_survey_id: 0,
  current_weight: 0,
  goal_weight: 0,
  cell_phone: null,
  gender: "",
  birthdate: null,
  subscription: null, /* SubscriptionModel */
  subscription_plan: null, /* SubscriptionPlanModel */
  intercom_id: "",
  firebase_token: "",
  restriction: "",
  verification_code: null,
  intercom_user_hash: "",
  is_finish_quiz: false,
  is_payed: false,
  is_password_changed: false,
  affid: null,
  tid: null,
  needVerificationCode: false };


export function CurrentUserModel(
$modelFactory,
ApiHttp,
CheckinModel,
UserMealPlanModel,
UserSubscriptionPlanModel,
UserSubscriptionModel)
{
  "ngInject";

  return (/*#__PURE__*/function (_$modelFactory) {_inherits(CurrentUser, _$modelFactory);function CurrentUser() {_classCallCheck(this, CurrentUser);return _possibleConstructorReturn(this, (CurrentUser.__proto__ || Object.getPrototypeOf(CurrentUser)).apply(this, arguments));}_createClass(CurrentUser, [{ key: "weekNumber", get: function get()

























        {
          try {
            return this.last_checkin.week_number;
          } catch (err) {
            return 0;
          }
        } }]);return CurrentUser;}($modelFactory(ApiHttp.authCheck, { defaults: userDefaults, map: { last_checkin: CheckinModel, first_checkin: CheckinModel, meal_plan: UserMealPlanModel, subscription_plan: UserSubscriptionPlanModel, subscription: UserSubscriptionModel }, actions: { query: { method: 'POST', isArray: false, afterRequest: function afterRequest(_ref) {var _ref$user = _ref.user,user = _ref$user === void 0 ? {} : _ref$user,need_verification_code = _ref.need_verification_code;return _objectSpread({}, user, { needVerificationCode: need_verification_code });} }, update: { method: 'PUT', isArray: false, url: "".concat(ApiHttp.account, "{id}/{?id}"), override: true } } })));


}